import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { IOuter } from '../../EmptyState.types';
import styles from './UnknownErrorSubtitle.scss';

export const UnknownErrorSubtitle: FC<IOuter> = () => (
  <p className={styles.subtitleNewBrandingStyles}>
    <FormattedMessage id="empty-state.server-error-subtitle" />
  </p>
);
